<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>{{ 'service.survey-service.question-final-decision-statuses.revised_split.title' | translate }}</span>
    <span class="spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="close()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content>
  <div class="container my-3">
    <div class="original-statement-box">
      <div class="original-statement-label">{{ 'modals.modal-split-question.original-statement' | translate }}</div>
      <div class="original-statement-text">{{ originalQuestion.question }}</div>
    </div>

    <div class="new-statements-section">
      <div class="new-statements-label">
        <mat-icon>call_split</mat-icon>
        {{ 'modals.modal-split-question.new-statements' | translate }}
      </div>

      <!-- Stesso app-single-question gia' riusato in modal-revise-question,
           una istanza per ogni split, cosi' tutti i campi della tipologia
           reale sono modificabili anche qui, non solo il testo dello
           statement. -->
      @for (question of newQuestions; track question.id; let i = $index) {
        <div class="split-statement-card">
          <div class="split-statement-header">
            <span class="split-index-badge">{{ i + 1 }}</span>
            <span class="split-statement-title">{{ 'modals.modal-split-question.new-statement-n' | translate: { n: i + 1 } }}</span>
            <button mat-icon-button type="button" class="remove-split-btn ml-auto" [disabled]="newQuestions.length <= 2"
              [matTooltip]="'generic.remove' | translate" (click)="removeSplit(i)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
          <div class="single-question-wrapper">
            <app-single-question
              [question]="question"
              [survey]="data.survey"
              [isResponse]="false"
              [editable]="true"
              [isDeletable]="false"
              [clonable]="false">
            </app-single-question>
          </div>
        </div>
      }

      <button mat-stroked-button color="primary" type="button" class="mt-2" (click)="addSplit()">
        <mat-icon class="mr-2">add</mat-icon>
        {{ 'modals.modal-split-question.add-statement' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center" class="dialog-actions-buttons">
  <button mat-stroked-button class="text-dark-purple border-purple mr-2" (click)="close()">{{ 'generic.cancel' | translate }}</button>
  <button mat-raised-button color="primary" (click)="save()"><mat-icon>save</mat-icon>{{ 'generic.buttons.save' | translate }}</button>
</mat-dialog-actions>
